<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="150">
                <FormItem :label="$t('img_lnk')"  prop="img_lnk">
                    <myUploadCompressedPic @getCompressImgAddr="setImgLnk" :original_url="formData.img_lnk" :lrz_flag="false" path="org/info"></myUploadCompressedPic>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('code')" prop="org_code">
                            <Input v-model="formData.org_code" disabled></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cname')" prop="org_cname">
                            <Input v-model="formData.org_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('mod_cname')" prop="mod_id">
                            <Select v-model="formData.mod_id" disabled>
                                <Option :value="item.mod_id" v-for="item in mods" :key="item.mod_id">{{item.mod_cname}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="org_level == '3'">
                        <FormItem :label="$t('org_grade')">
                            <Select v-model="formData.org_grade" disabled>
                                <Option :value="item.key" v-for="item in org_grade" :key="item.key">{{item.value}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_cid')" prop="org_cid">
                            <Input v-model="formData.org_cid" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_cor')" prop="org_cor">
                            <Input v-model="formData.org_cor" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_contact')" prop="link_cname">
                            <Input v-model="formData.link_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('org_mobile')" prop="link_mobile">
                            <Input v-model="formData.link_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_cname')" prop="cu_cname">
                            <Input v-model="formData.cu_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_mobile')" prop="cu_mobile">
                            <Input v-model="formData.cu_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('cu_ser_time')" prop="cu_ser_time">
                            <Input v-model="formData.cu_time_area" :placeholder="$t('cu_start_time')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12" v-if="org_level == '3'">
                        <FormItem :label="$t('status')" prop="org_status">
                            <RadioGroup :key="index" v-model="formData.org_status" v-for="(item, index) in org_status">
                                <Radio :label="item.key" disabled>{{item.value}}</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('recv_cor_cname')" prop="recv_cname">
                            <Input v-model="formData.recv_cname" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('phone')" prop="recv_mobile">
                            <Input v-model="formData.recv_mobile" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('addrvalue')" prop="addrLabel">
                    <Cascader :data="addrData" :filterable="true" trigger="hover" v-model="formData.addrLabel" @on-change = "addrValueChang"></Cascader>
                </FormItem>
                <FormItem :label="$t('org_addr')" prop="org_addr">
                    <Input v-model="formData.org_addr" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('lng')" prop="">
                            <Input v-model="formData.lng" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem :label="$t('lat')" prop="">
                            <Input v-model="formData.lat" :placeholder="$t('input')"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                        <FormItem :label="$t('org_admin_code')" prop="org_admin_code">
                            <Input v-model="formData.org_admin_code" disabled></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('cdesc')" prop="org_cdesc">
                    <Input v-model="formData.org_cdesc" type="textarea" :autosize="{minRows: 2,maxRows: 3}" :placeholder="$t('input')"></Input>
                </FormItem>
                <FormItem :label="$t('build_img_lnk')" prop="build_img_lnk">
                    <myCropImg :fixedNumber='[800,520]' :autoCropWidthHeight='[800,520]' crop_width="850px" crop_height="570px" @cropImgUpload="setBuildImg"  :original_url="this.formData.build_img_lnk" path="org/build"></myCropImg>
                </FormItem>
                <FormItem :label="$t('cid_img_lnk')" prop="cid_img_lnk">
                    <myUploadCompressedPic :original_url="formData.cid_img_lnk" @getCompressImgAddr="setCompressImgAddr" path="org/cid"></myUploadCompressedPic>
                </FormItem>
                <Row>
                    <Col span="12"><FormItem :label="$t('add_user')"><Input v-model="formData.add_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('add_time')"><Input v-model="formData.add_time" disabled></Input></FormItem></Col>
                </Row>
                <Row>
                    <Col span="12"><FormItem :label="$t('upd_user')"><Input v-model="formData.upd_user" disabled></Input></FormItem></Col>
                    <Col span="12"><FormItem :label="$t('upd_time')"><Input v-model="formData.upd_time" disabled></Input></FormItem></Col>
                </Row>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    import myUploadCompressedPic from '../../../components/myUploadCompressedPic'
    import myCropImg from '../../../components/myCropImg'
    import addr from '../../../utils/addr/index'
    export default {
        components:{
            myCropImg,
            myUploadCompressedPic
        },
        data:function(){
            return{
                relist:false,
                Loading:true,
                mods:[],
                formData: {
                    org_id: "",
                    img_lnk: "",
                    org_code: "",
                    org_cname: "",
                    mod_id: "",
                    org_cid: "",
                    org_cor: "",
                    link_cname: "",
                    link_mobile: "",
                    cu_time_area: "",
                    build_img_lnk: "",
                    cid_img_lnk: "",
                    cu_cname: "",
                    cu_mobile: "",
                    org_admin_code: "",
                    org_cdesc: "",
                    org_prov: "",
                    org_city: "",
                    org_area: "",
                    org_addr: "",
                    addrLabel:[],
                    lng:'0', // 经度
                    lat:'0',  // 维度
                    org_grade: '',
                    org_status: '',
                    recv_cname: "",
                    recv_mobile: "",
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                addrData: [],
                rule: {
                    org_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cu_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    link_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    admin_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_prov: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_city: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    mod_id: [{required: true, message: this.$t('input'), trigger: 'change'}],
                    org_area: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    org_addr: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    addrLabel: [{required: true, message: this.$t('input'), trigger: 'change', type:'array'}],
                },
                org_grade: [],
                org_level: 0,
                org_status: []
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.org_level = this.$base.getRequest().org_level;
            this.getInfo();
            setTimeout(() => {
                this.addrData = addr.getAddrData()
            }, 500)
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            setBuildImg: function (file_path) {
                this.formData.build_img_lnk = file_path;
            },
            //压缩图片,把压缩图片的后台地址返回this.formData.cid_img_lnk(营业执照)
            setCompressImgAddr: function(compressed_addr){
                this.formData.cid_img_lnk = compressed_addr;
            },
            //截图后的图片,截图图片的后台地址返回this.formData.img_lnk
            setImgLnk: function (file_path) {
                this.formData.img_lnk = file_path;
            },

            getInfo: function(){
                var org_id = this.$base.getRequest().org_id;
                if(!org_id){
                    return;
                }
                var data = {
                    org_id
                };
                this.$base.showLoading();
                this.$request.sendPost("org-down-s2/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.mods = this.mods.concat(data.mods);
                        this.org_grade = this.org_grade.concat(data.org_grade);
                        this.org_status = this.org_status.concat(data.org_status);
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.formData.addrLabel = data.info.org_addr_code.split(',');
                        this.Loading = false;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            addrValueChang(value,selectedData){
                this.formData.org_prov = selectedData[0].label;
                if(selectedData.length == 3){
                    this.formData.org_city = selectedData[1].label;
                    this.formData.org_area = selectedData[2].label;
                }
                else if(selectedData.length == 2) {
                    this.formData.org_area = '';
                    this.formData.org_city = selectedData[1].label;
                }
                else if(selectedData.length == 1) {
                    this.formData.org_area = '';
                    this.formData.org_city = '';
                }
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        /*console.log(a);
                        console.log(b);*/
                        var url = 'org-down-s2/upd';
                        this.formData.org_addr_code = this.formData.addrLabel.join(',');
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/down/downs2_upd.vue